module.exports = __webpack_public_path__ + "img/hr-level1_idle_gun.49b28e6e.png";